import { useTelemetry, Telemetry } from "./telemetry-context"

// This file contains functions that allow components to `emit` events to the
// page. Consumers can `listen` for these events to trigger functions.

const listeners = {}

export const EVENTS = {
  MODAL_OPEN: "modal_open",
  BUTTON_CLICK: "button_click"
}

/**
 * Broadcasts an event that listeners can detect.
 *
 * @param {String} name
 * @param {Object} payload
 */
export function emit(name, payload) {
  if (listeners[name]) {
    listeners[name].forEach(callback => callback(payload))
  }
}

/**
 * Listens for an event with a specific name, and invokes the callback function
 * when it occurs. Returns a function that can be used to stop listening.
 *
 * @param {String} name
 * @param {Function} fn
 * @returns {Function} unsubscribe
 */
export function listen(name, fn) {
  if (!listeners[name]) {
    listeners[name] = []
  }

  listeners[name].push(fn)

  return () => {
    listeners[name] = listeners[name].filter(callback => callback !== fn)
  }
}

/**
 * Clears all listeners. Useful when navigating without a full page reload.
 */
export function reset() {
  Object.keys(listeners).forEach(key => {
    listeners[key] = []
  })
}

export { useTelemetry, Telemetry }
